module.exports = __webpack_public_path__ + "img/FQC.ce105c47.png";